export const API = {
  appEnv: import.meta.env.VITE_APP_ENVIRONMENT,
  appStorage: import.meta.env.VITE_APP_STORAGE,
  appUrl: import.meta.env.VITE_APP_URL,
  baseAuthEndpoint: import.meta.env.VITE_API_AUTH_BASE_URL,
  baseEndpoint: import.meta.env.VITE_API_BASE_URL,
  supportUrl:
    'https://support.easyship.com/hc/en-us/articles/32040478043410-Buyer-Shipping-Insurance-via-Tracking',
} as const;
